import { ScrollView } from "react-native";
import { VStack } from "@/components/ui/vstack";
import ChatBubble from "./ChatBubble";
import LoadingChatBubble from "@/studio/components/ai/LoadingChatBubble";


export default function PromptDialog({ messages, ...containerProps }) {

    const mockData = [
        {type: "sent", text: "This is a prompt the user has sent"},
        {type: "received", text: "This is the result the user has received‚"},
        {type: "sent", text: "This is a really long prompt the user has sent. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. Donec sollicitudin molestie malesuada. Cras ultricies ligula sed magna dictum porta. Nulla quis lorem ut libero malesuada feugiat. Curabitur aliquet quam id dui posuere blandit. Quisque velit nisi, pretium ut lacinia in, elementum id enim. Vivamus suscipit tortor eget felis porttitor volutpat. Donec rutrum congue leo eget malesuada. Andthisisareallylongworkwithoutanybreakstocheckifthechatbubblewillbreakcorrectly"}
    ]

    return (<ScrollView {...containerProps} contentContainerClassName="gap-4">
        <VStack className="gap-4">
            {
                messages.map((item, index) => {
                    if (item.type === "loading") {
                        return <LoadingChatBubble type={'received'} key={index} />
                    } else {
                        return <ChatBubble key={index} type={item.type} message={item.text} />
                    }
                })
            }
        </VStack>
    </ScrollView>)

}
